module.exports = __webpack_public_path__ + "img/Phorto_1__People_and_Pleasures_984_102_1_Fortier_Family.dba6514f.jpg";